import React from 'react'
import { Box, Button, Card, Grid, Stack, Typography } from '@mui/material';
import Iconify from '../../../components/Iconify';

const AdsCard = ({ adss, onEdit, onDisable, onEnable, onDelete }) => {

    const { _id, title, url, image, status } = adss;
    return (
        <Card sx={{ mt: '8px' }}>
            <Grid container>
                <Grid item sm={5}>
                    <img
                        alt="logo"
                        style={{ width: '100%', height: '350px', objectFit: 'cover' }}
                        src={`${process.env.REACT_APP_IMAGE}${image}`}
                    />
                </Grid>
                <Grid item sm={7} p={3}>
                    <Stack direction={'column'}>
                        <Typography variant="h4" color="#A7202C">
                            {title}
                        </Typography>
                        <Typography variant="h5" color="black">
                            {url}
                        </Typography>
                        <Stack direction="row" sx={{ mt: 1 }} justifyContent="space-between">
                            <Typography variant="subtitle2">Trạng thái: </Typography>
                            <Stack direction="row" spacing={2}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        background: status === 'Disable' ? '#ff9a001c' : '#1aff0012',
                                        color: status === 'Disable' ? '#f39c12' : '#42f233',
                                        p: '2px',
                                        borderRadius: '3px',
                                    }}
                                >
                                    <Iconify icon={'akar-icons:check-box'} sx={{ width: 16, height: 16, mr: 0.5 }} />
                                    <Typography fontWeight={'bold'} variant="caption">
                                        {status}
                                    </Typography>
                                </Box>
                            </Stack>
                        </Stack>

                        <Stack sx={{ mt: 1 }} direction="row" justifyContent="space-between">
                            <Stack direction="row" spacing={1}>
                                <Button variant="outlined" color="error"
                                    onClick={() => onDelete(_id)}
                                >
                                    Xóa quảng cáo
                                </Button>
                                <Button variant="outlined" color="success"
                                    onClick={() => onEdit(_id)}
                                >
                                    Cập nhật
                                </Button>
                                {status === 'Disable' ? (
                                    <Button variant="outlined"
                                        onClick={() => onEnable(_id)}
                                    >
                                        Kích hoạt
                                    </Button>
                                ) : (
                                    <Button variant="outlined" color="warning"
                                        onClick={() => onDisable(_id)}
                                    >
                                        Ngừng hoạt động
                                    </Button>
                                )}
                            </Stack>
                        </Stack>
                    </Stack>
                </Grid>
            </Grid>
        </Card>
    )
}

export default AdsCard